// Copyright 2017 Sorama B.V.

import { bindingMode, customAttribute, DOM, inject } from "aurelia-framework";
import { HelpModal } from "modules/modals/Help/HelpModal";

@customAttribute("highlight", bindingMode.twoWay)
@inject(DOM.Element)
export class Highlight {
    // Title to highlight
    private value: string;
    private context: HelpModal;

    constructor(private readonly input: HTMLInputElement) {}

    private bind(context: HelpModal): void {
        this.context = context;
    }

    private attached(): void {
        if (this.context && this.context.state && this.context.state.highlightName == this.value) {
            this.input.scrollIntoView(true);
            this.input.classList.add("highlight-blink");
        }
    }
}
